import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import pt from "vuetify/lib/locale/pt";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: {
          lighten2: "#5255C6",
          base: "#3E4095",
          darken2: "#222476",
        },
        secondary: {
          base: "#0098DA",
          darken1: "#0287C0",
          darken2: "#00577D",
        },
        grey: {
          lighten5: "#EDF3F5",
          lighten4: "#DFE3E5",
          base: "#1E1E1E",
        },
      },
    },
  },
  lang: {
    locales: { pt },
    current: "pt",
  },
  icons: {
    iconfont: "fa",
  },
});
